import { GoogleLogin } from '@react-oauth/google';
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/useAuth';

const THEME_STORAGE_KEY = 'searchx:theme';

export function LoginPage() {
  const { isAuthenticated, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect to the page the user originally tried to visit, or default to /.
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? '/';

  useEffect(() => {
    try {
      const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
      if (savedTheme !== 'dark') document.documentElement.dataset.theme = 'light';
    } catch {
      document.documentElement.dataset.theme = 'light';
    }
  }, []);

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <section className="login-hero" aria-labelledby="login-title">
          <div className="brand-lockup login-brand">
            <span className="brand-mark" aria-hidden="true">sx</span>
            <h1 id="login-title">searchx</h1>
            <p className="tagline">KYC/AML intelligence workspace</p>
          </div>

          <div className="login-statement">
            <p>
              Federated registry search with source visibility for KYB workflows.
            </p>
          </div>

          <div className="login-capabilities" aria-label="Workspace capabilities">
            <span>Registry sources</span>
            <span>Result audit trail</span>
            <span>Click feedback loop</span>
          </div>
        </section>

        <aside className="login-card" aria-label="Sign in">
          <span className="login-eyebrow">Secure workspace</span>
          <div className="login-copy">
            <h2>Sign in to continue</h2>
            <p>Registry-backed company and person search with auditable results.</p>
          </div>
          <div className="login-button-wrapper">
            <GoogleLogin
              onSuccess={(response) => {
                if (response.credential) {
                  const ok = login(response.credential);
                  if (ok) navigate(from, { replace: true });
                }
              }}
              onError={() => {
                // Google login popup was closed or errored; nothing to do.
              }}
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
            />
          </div>
        </aside>
      </div>
    </div>
  );
}
